import { getJobByIDAPI } from "@services/jobsAPI"

//use this to fetch job data in many places throughout app where jobs are selected from dropdowns
//do this so we have up to date job data (especially for job IsLocked, POI Counts, and anything else that could be edited) when navigating across pages
//helps us give more accurate messages: for example, telling user job is locked, or that job is locked and has POIs
export const fetchJobData = async(selectedJob, showError, setSelectedJob, setStoredJob, setHasUnsavedChanges = null) => {

    let jobData = selectedJob

    if(!jobData) return
    
    const response = await getJobByIDAPI(selectedJob.value)

    if(!response.success){
        showError(`There was a problem getting job data: ${response.message}`)
        return
    } else {
        const job = response.data
        jobData = {
            ...jobData,
            ...(job || {})
        }
    }

    setSelectedJob(jobData)
    setStoredJob(jobData)

    if(setHasUnsavedChanges){
        setHasUnsavedChanges(false)
    }
}